




























import { SubjectItemDto } from '@/services/subject';
import { Vue, Component, Prop, PropSync, Watch } from 'vue-property-decorator';
import DragMode from '../dimension/drag-mode.vue';
import SqlMode from './sql-mode.vue';

@Component({
  components: { DragMode, SqlMode }
})
export default class SubjectForm4 extends Vue {
  @Prop() syncMode!: number;
  @Prop() subFieldList!: SubjectItemDto[];
  @PropSync('subSyncDefs') syncSubSyncDefs!: any;

  inputdataConfig: any[] = [];

  @Watch('subFieldList')
  onSubFieldListChange() {}

  @Watch('syncSubSyncDefs')
  onSyncSubSyncDefsChange() {
    this.inputdataConfig = JSON.parse(JSON.stringify(this.syncSubSyncDefs.inputdataConfig));
  }

  @Watch('inputdataConfig')
  onInputdataConfigChange() {
    this.syncSubSyncDefs.inputdataConfig = this.inputdataConfig;
  }

  get xWidth() {
    return 200 * this.subFieldList.length + 120;
  }

  created() {
    this.inputdataConfig = JSON.parse(JSON.stringify(this.syncSubSyncDefs.inputdataConfig));
  }

  addList() {
    this.inputdataConfig.push({});
  }
  removeList(index: number) {
    this.inputdataConfig.splice(index, 1);
  }
}
